import { jsxs as v, jsx as r } from "react/jsx-runtime";
import { zIndices as I } from "@fcamna/shared-component-foundations";
import { c as d } from "./index-65016bfa.mjs";
import { useState as k, useRef as z, useCallback as A, useEffect as y } from "react";
import { createPortal as T } from "react-dom";
import l, { css as m } from "styled-components";
import { u as F } from "./usePopoverIndex-b3a93ecd.mjs";
import { u as H } from "./useQuantum-50e8fd44.mjs";
import { u as P } from "./useClient-0bbce34e.mjs";
import { u as S } from "./useSlots-a1aa6a84.mjs";
import { b as j } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import { CloseButton as q } from "./closeButton.js";
import { Disclosures as K } from "./disclosure.js";
import { FocusTrap as U } from "./focusTrap.js";
import { h as D } from "./hTag-27bb1617.mjs";
import { m as E, A as L } from "./index-5d51183d.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./tslib.es6-59e1c9d8.mjs";
const Q = l.div`
  &.ModalWindow__container-wrapper {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalContainerWrapper)};
  }
`, G = l(E.div)`
  &.ModalWindow__container {
    ${({
  theme: {
    components: { modalWindow: o },
    componentStyles: e
  }
}) => m(o.ModalContainer, e)};
  }
`, J = l.div`
  &.ModalWindow__content {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalContent)};
  }
`, R = l.div`
  &.ModalWindow__header {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalHeader)};
  }
`, V = l(D)`
  &.ModalWindow__title {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalTitle)};
  }
`, X = l.div`
  &.ModalWindow__close {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalCloseButton)};
  }
`, Bo = ({
  children: o,
  onClose: e,
  hasClose: n = !0,
  id: _,
  headingLevel: s = "h1",
  idProps: t,
  accessibilityOptions: f,
  className: w,
  ...u
}) => /* @__PURE__ */ v(
  R,
  {
    ...u,
    className: d([w, "ModalWindow__header"]),
    children: [
      /* @__PURE__ */ r(
        V,
        {
          id: _,
          as: s,
          className: d(["ModalWindow__title"]),
          "aria-hidden": !o,
          children: o
        }
      ),
      /* @__PURE__ */ r(X, { className: d(["ModalWindow__close"]), children: n && /* @__PURE__ */ r(
        q,
        {
          id: t == null ? void 0 : t.closeButtonId,
          onClick: e,
          size: "large",
          ...f
        }
      ) })
    ]
  }
), Y = l.div`
  &.ModalWindow__body {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalBody)};
  }
`, Io = ({ children: o, className: e, ...n }) => /* @__PURE__ */ r(
  Y,
  {
    "data-id": "modal-body",
    ...n,
    className: d([e, "ModalWindow__body"]),
    children: o
  }
), Z = l.div`
  &.ModalWindow__footer {
    ${({
  theme: {
    components: { modalWindow: o }
  }
}) => m(o.ModalFooterWrapper)};
  }
`, ko = ({ children: o, placement: e = "left", ...n }) => /* @__PURE__ */ r(
  Z,
  {
    ...n,
    className: d(["ModalWindow__footer", `ModalWindow__footer--${e}`]),
    children: o
  }
), C = ({
  isOpen: o,
  onClose: e,
  variant: n = "medium",
  children: _,
  bgOverlayColor: s = "rgba(0, 0, 0, 0.3)",
  disclosures: t,
  accessibilityOptions: f = {},
  className: w,
  ...u
}) => {
  const b = H({ label: "Modal Window" }), g = F(o, C.zIndex), p = P(), [$, N] = k(!1), i = z(null), x = j("dialog", { ariaModal: !0, ...f }), M = A(() => {
    var c, W, h;
    if (!(i != null && i.current) || n === "fullPage" || !o)
      return;
    const a = (c = i.current) == null ? void 0 : c.querySelector('div[data-id="modal-body"]');
    (W = i.current) == null || W.setAttribute("style", "height: 100%"), N((a == null ? void 0 : a.clientHeight) < (a == null ? void 0 : a.scrollHeight)), (h = i.current) == null || h.removeAttribute("style");
  }, [o, n]);
  S("resize", o ? M : void 0), y(M, [M]), y(() => {
    p.isClient && (p.document.body.style.overflow = o ? "hidden" : "");
  }, [o, M, p, i]);
  const B = (a) => {
    a.code === "Escape" && (e == null || e());
  };
  return p.isClient ? T(
    /* @__PURE__ */ r(L, { children: o && /* @__PURE__ */ r(
      Q,
      {
        onClick: (a) => {
          var c;
          (c = i.current) != null && c.contains(a.target) || e == null || e();
        },
        className: d(["ModalWindow__container-wrapper", `ModalWindow__container-wrapper--${n}`]),
        style: { background: s, zIndex: g },
        children: /* @__PURE__ */ r(
          G,
          {
            ref: i,
            role: "dialog",
            initial: "closed",
            animate: o ? "open" : "closed",
            exit: "closed",
            transition: { duration: 0.3 },
            variants: { closed: { opacity: 0 }, open: { opacity: 1 } },
            onKeyUp: B,
            ...x,
            ...b,
            ...u,
            className: d([
              "ModalWindow__container",
              `ModalWindow__container--${n}`,
              {
                "ModalWindow__container--overflown": $
              },
              w
            ]),
            children: /* @__PURE__ */ v(
              U,
              {
                open: !0,
                disableEnforceFocus: !0,
                children: [
                  /* @__PURE__ */ r(J, { className: d(["ModalWindow__content", `ModalWindow__content--${n}`]), children: _ }),
                  t && /* @__PURE__ */ r(
                    K,
                    {
                      disclosureContent: t == null ? void 0 : t.disclosureContent,
                      id: t == null ? void 0 : t.id,
                      className: t == null ? void 0 : t.className,
                      disclosureTitleColor: t == null ? void 0 : t.disclosureTitleColor,
                      style: t == null ? void 0 : t.style
                    }
                  )
                ]
              }
            )
          }
        )
      }
    ) }),
    document.body
  ) : null;
};
C.zIndex = I.modal;
export {
  Io as ModalBody,
  ko as ModalFooter,
  Bo as ModalHeader,
  C as ModalWindow
};
